import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { ProductCategory } from "../../models/product-category.model";

@Injectable()
export class ProductCategoryProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getByID(id: number): Observable<ProductCategory> {
    return this.http
      .get<ProductCategory>(`${this.url}/product-categories/${id}`)
      .map(response => {
        return new ProductCategory(response);
      })
      .catch(this.handleError)
  }

  getChildrenByID(id: number, withProducts: boolean): Observable<ProductCategory[]> {
    return this.http
      .get<ProductCategory[]>(`${this.url}/product-categories/${id}/children/${withProducts ? 'products' : ''}`)
      .map(response => {
        return response.map((productCategory) => new ProductCategory(productCategory));
      })
      .catch(this.handleError)
  }

  getAll(): Observable<ProductCategory[]> {
    return this.http
      .get<ProductCategory[]>(`${this.url}/product-categories`)
      .map(response => {
        return response.map((productCategory) => new ProductCategory(productCategory));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/product-category/product-category.ts